export default "__VITE_ASSET__348cea1d__"